(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("tether"), require("react-dom"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["tether", "react-dom", "react"], factory);
	else if(typeof exports === 'object')
		exports["TetherComponent"] = factory(require("tether"), require("react-dom"), require("react"));
	else
		root["TetherComponent"] = factory(root["Tether"], root["ReactDOM"], root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__7__) {
return 